import { Highlight } from 'react-instantsearch-dom'
import classNames from 'classnames'
import { EventHit, GetItemPropsNoAnalyticsFn, Hit } from './index'

const type = (hit: Hit | EventHit) => {
  if (hit.content_type === 'question') return 'Question'
  if (hit.content_type === 'article') return 'Article'
  if (hit.content_type === 'ideation') return 'Idea'
  if (hit.content_type === 'event') return 'Event'
  if (hit.content_type === 'productUpdate') return 'Product Update'
  return 'Discussion'
}

interface Props {
  key: string
  inputValue: string
  hits: Array<Hit | EventHit>
  highlightedIndex: number | null
  style?: CSSStyleDeclaration
  getItemProps: GetItemPropsNoAnalyticsFn
  exclude?: number[]
  searchById?: boolean
  finalInput: string
}

const HitContainerControl = ({
  key,
  inputValue,
  hits,
  highlightedIndex,
  getItemProps,
  style,
  exclude,
  searchById,
  finalInput
}: Props) => {
  return (
    <div key={key ?? 'results'} className='algolia-hit-container' style={style}>
      {inputValue && !hits.length
        ? (
          <div className='algolia-hit-container__header'>
            <span className='algolia-hit-container__header-text'>
              No result found for:
            </span>
            {' '}
            {inputValue}
          </div>)
        : null}
      <ul className='algolia-search-results'>
        {hits.filter(hit => {
          if (!searchById) return hit

          return hit.id === parseInt(finalInput) || hit.private_id === parseInt(finalInput)
        }).map((hit, index) => {
          const disabled = typeof exclude !== 'undefined' && Array.isArray(exclude) && ((exclude.includes(typeof hit.id === 'string' ? parseInt(hit.id) : hit.id) || exclude.includes(hit.id)) || exclude.includes(hit.private_id ?? 0))
          return (
            <li
              key={hit.id}
              className={classNames(
                'algolia-search-result',
                { disabled: disabled },
                { highlighted: highlightedIndex === index }
              )}
              {...getItemProps({ item: hit, index: index, disabled: disabled })}
            >
              <span className='algolia-hit-item'>
                <Highlight attribute='title' hit={hit} tagName='strong' /><br />
                <span>{type(hit)} by {hit.username}</span>
              </span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default HitContainerControl
